<app-layout-main [pageMetadata]="{ title: originalAppName() }" [layoutSize]="'small'" [design]="'clean'">
	<lib-card [title]="'Refund policy'">
		Any client may request a full refund within a 30 days of purchase. To request such refund please send us an
		e-mail at <a [href]="refundHref">{{ refundEmail }}</a>
	</lib-card>
</app-layout-main>
